import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/meeting_placement`;

export const ACTION_TYPES = {
  FETCH_MEETINGPLACEMENT_LIST: 'meetingplacement/FETCH_MEETINGPLACEMENT_LIST',
  FETCH_MEETINGPLACEMENT: 'meetingplacement/FETCH_MEETINGPLACEMENT',
  CREATE_MEETINGPLACEMENT: 'meetingplacement/CREATE_MEETINGPLACEMENT',
  UPDATE_MEETINGPLACEMENT: 'meetingplacement/UPDATE_MEETINGPLACEMENT',
  DELETE_MEETINGPLACEMENT: 'meetingplacement/DELETE_MEETINGPLACEMENT',
  RESET: 'meetingplacement/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}, //defaultValue
}

// REDUCER
const webinarPlacementReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MEETINGPLACEMENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MEETINGPLACEMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_MEETINGPLACEMENT):
    case REQUEST(ACTION_TYPES.UPDATE_MEETINGPLACEMENT):
    case REQUEST(ACTION_TYPES.DELETE_MEETINGPLACEMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_MEETINGPLACEMENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MEETINGPLACEMENT):
    case FAILURE(ACTION_TYPES.CREATE_MEETINGPLACEMENT):
    case FAILURE(ACTION_TYPES.UPDATE_MEETINGPLACEMENT):
    case FAILURE(ACTION_TYPES.DELETE_MEETINGPLACEMENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MEETINGPLACEMENT_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MEETINGPLACEMENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_MEETINGPLACEMENT):
    case SUCCESS(ACTION_TYPES.UPDATE_MEETINGPLACEMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_MEETINGPLACEMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default webinarPlacementReducer;

// ACTIONS

export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_MEETINGPLACEMENT_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getWebinarPlacementbyCourseID = (id) => ({
    type: ACTION_TYPES.FETCH_MEETINGPLACEMENT_LIST,
    payload: axios.get(`${apiUrl}/course/${id}`),
  });

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_MEETINGPLACEMENT,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = (entity, idcourse) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MEETINGPLACEMENT,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getWebinarPlacementbyCourseID(idcourse));
  return result;
};

export const updateEntity = (entity, id, idcourse) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MEETINGPLACEMENT,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getWebinarPlacementbyCourseID(idcourse));
  return result;
};

export const deleteEntity = (id, idcourse) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MEETINGPLACEMENT,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  dispatch(getWebinarPlacementbyCourseID(idcourse));
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
